// extracted by mini-css-extract-plugin
export default {"window":"deep-dive-window-page_window__3kYwX","appHeader":"deep-dive-window-page_appHeader__h3iX7","contentBody":"deep-dive-window-page_contentBody__YSob9"};